export const getInitials = (name) => {
    if (!name || typeof name !== "string" || !name.trim()) return "N/A"; // Kiểm tra null, undefined, hoặc chuỗi rỗng

    const words = name.trim().split(" ");
    if (words.length === 0) return "N/A"; // Đề phòng trường hợp tách xong vẫn rỗng

    const firstInitial = words[0]?.charAt(0)?.toUpperCase() || "";
    const lastInitial = words[words.length - 1]?.charAt(0)?.toUpperCase() || "";

    return firstInitial + lastInitial || "N/A";
};

export const getInitialsGroup = (name) => {
    if (!name) {
        return ''; // Return empty if name is undefined, null, or empty string
    }

    const words = name.split(' ').filter(Boolean); // Split the name into words and remove empty strings
    let initials = '';

    // Take the first two words' initials, if they exist
    for (let i = 0; i < 2; i++) {
        if (words[i] && words[i][0]) {
            initials += words[i][0].toLowerCase(); // Get the first letter of each word
        }
    }

    return initials;
};

// Function to adjust the text color based on the background luminance
export const adjustTextColor = (backgroundColor) => {
    const hsl = backgroundColor.match(/\d+/g);  // Extract HSL values
    const hue = hsl[0];  // Hue value (0-360)
    const saturation = hsl[1];  // Saturation value (0-100)
    const lightness = parseInt(hsl[2], 10);  // Lightness value (0-100)

    // If the background is dark, make the text lighter; if the background is light, make the text darker
    let textLightness = lightness < 50 ? lightness + 50 : lightness - 50;

    // Ensure the lightness stays within the 0-100 range
    textLightness = Math.min(100, Math.max(0, textLightness));

    // Return the adjusted color with the same hue and saturation, but modified lightness
    return `hsl(${hue}, ${saturation}%, ${textLightness}%)`;
};

export const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str?.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `hsl(${hash % 360}, 50%, 70%)`; // Tạo màu ngẫu nhiên
};